module.exports = __webpack_public_path__ + "img/upload-3rd-8.eb390a1c.png";